import { useEffect, useState } from "react";
import type { FieldValues, UseFormReset } from "react-hook-form";

interface State {
  default: string;
  isDone: string;
}

export const useAutoResetState = <T extends FieldValues>(
  initialState: State,
  cb: {
    reset: UseFormReset<T>;
    args: T;
  },
  timeOut = 5000,
) => {
  const [currentState, setCurrentState] = useState(initialState.default);
  const [isUpdated, setUpdated] = useState(false);

  const updateState = () => {
    setCurrentState(initialState.isDone);
    setUpdated(true);
  };

  useEffect(() => {
    if (!isUpdated) return;
    const timeout = setTimeout(() => {
      setCurrentState(initialState.default);
      cb.reset(cb.args);
    }, timeOut);

    return () => clearTimeout(timeout);
  }, [currentState, isUpdated, initialState, timeOut, cb]);
  return { currentState, updateState };
};
